export default "__VITE_ASSET__6acd0373__"